import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { NavigationBlock, NavigationBlockRecursiveItem, INavigationBlockItemRecursive } from '@cbridge-tools/navigation-block';
import { externalReportingNavigationPropsSelector } from './ExternalReportingNavigation.selector';

// Server → reports tree, rendered with the shared navigation block (like the Client Symbols
// pools/servers tree). A server row has no route of its own, so it only expands/collapses.
export const ExternalReportingNavigation: FunctionComponent = () => {
  const { t } = useTranslation();
  const { groups, isLoading } = useSelector(externalReportingNavigationPropsSelector);

  const treeItems: INavigationBlockItemRecursive[] = groups.map((group) => ({
    value: group.serverId,
    label: group.serverName,
    href: '',
    items: group.reports,
    isExpandedByDefault: true,
  }));

  return (
    <NavigationBlock
      header={t('text:navigation.config.externalReporting.reports')}
      items={treeItems}
      isLoading={isLoading}
      NavigationItemComponent={NavigationBlockRecursiveItem}
    />
  );
};
